module.exports = __webpack_public_path__ + "static/media/perfilAnguloInterno.e237cd36.jpg";